import TenantDashboard from '../../components/settings/tenant/TenantDashboard'

const Dashboard = () => {
  return (
    <div className="mb-2 flex w-full flex-col">
      <TenantDashboard />
    </div>
  )
}

export default Dashboard
